/*
 * @Auther: liuguangsheng1
 * @Date: 2021-08-25 22:01:05
 * @LastEditTime: 2021-10-21 18:26:07
 * @Description:
 */
import {
    runAfterFirstMounted,
    registerMicroApps,
    start,
    addGlobalUncaughtErrorHandler,
    loadMicroApp,
} from 'qiankun'
import { isProduct } from './utils/constants'
import { webParseURL } from '@retailfe/retail-utils'
import microStore from './micro-store'
import { queryAuthority } from '@/api/menu'
import store from './store/index'
// import { setMicroApps, startMicroApps } from '@/main'
// import mockApps from './mock-app'
// TODO 可以结合打包变量判断，太懒了，这样快
const mockApps = false

const groupMenu = (menu) => {
    let arr = []
    const getMenu = (menu, parent = []) => {
        menu.forEach((item) => {
            if (item.childrenMenuList && item.childrenMenuList.length > 0) {
                getMenu(item.childrenMenuList, item)
                //TODO 二级菜单也要放到应用里
                if (item.level && item.level === 3) {
                    item.parent = parent
                    arr.push(item)
                }
            } else {
                //TODO 暂无三级菜单
                if (item.level && item.level < 4) {
                    item.parent = parent
                    arr.push(item)
                }
            }
        })
    }
    getMenu(menu)
    return arr
}

export const getApps = (data) => {
    return data.map((item) => {
        return {
            ...item,
            container: '#subapp', // 子应用挂载的div
            props: {
                routerBase:
                    typeof item.activeRule === 'string'
                        ? item.activeRule.split('/')[1]
                        : item.activeRule, // 下发基础路由
                getGlobalState: microStore.getGlobalState, // 下发getGlobalState方法
            },
        }
    })
}

const initSubApp = (menus = []) => {
    if (!menus || !Array.isArray(menus) || !menus.length) {
        throw new Error('接口没有菜单导入，无法创建子应用，请联系后端')
    }
    let defaultApp = null
    let subApps = []
    // 获取所有的非主应用的菜单

    let microApps = menus.map((item, index) => {
        // TODO https -> http

        if (item.url.indexOf('http') === -1) {
            item.url = 'https:' + item.url
        }
        const { host, relative } = webParseURL(item.url)
        // FIX 修复子应用路由跳转后不渲染页面问题，用于激活微应用
        // const activeRule = `/${item.code}`
        const activeRule = `/${host && host.split('.') && host.split('.')[0]}`
        // FIX 用于菜单点击切换路由
        const activeLinkUrl = `${activeRule + relative}`
        // 预发环境URL替换
        if (!isProduct) {
            item.url = item.url.split('.jd.com').join('-pre.jd.com')
        }
        return {
            id: item.code,
            name: `${index}`,
            title: item.name,
            entry: item.url,
            activeRule,
            activeLinkUrl,
            parent: item.parent,
        }
    })
    subApps = getApps(microApps)
    console.log('subApps', subApps)
    store.dispatch('app/setMicro', subApps)
    // return
    registerMicroApps(subApps, {
        beforeLoad: [
            (app) => {
                console.log('before load', app)
            },
        ],
        beforeMount: [
            (app) => {
                console.log('before mount', app)
            },
        ],
        afterUnmount: [
            (app) => {
                console.log('after unload', app)
            },
        ],
    })
    // 设置默认子应用，因为主应用有一个默认页，所以就禁止渲染默认子应用了，需要的可以打开，或者说你的主应用就是一个架子或者壳，菜单全都是按模块分的子应用一定要开启默认子应用，不过如果是主应用只做架子的话，有另外一种方式更合适，这里等会再说
    if (!defaultApp) defaultApp = subApps[0].path
    // setDefaultMountApp(defaultApp);
    // 第一个子应用加载完毕回调
    runAfterFirstMounted((app) => {
        console.log('runAfterFirstMounted', app)
    })
    // 启动微服务
    start()
    // start({
    //     excludeAssetFilter: (assetUrl) => {
    //         console.log(assetUrl)
    //         const whiteList = []
    //         const whiteWords = ['qq.com']
    //         if (whiteList.includes(assetUrl)) {
    //             return true
    //         }
    //         console.log(
    //             'exclude......',
    //             whiteWords.some((w) => {
    //                 return assetUrl.includes(w)
    //             })
    //         )
    //         return whiteWords.some((w) => {
    //             return assetUrl.includes(w)
    //         })
    //     },
    // })
    // 设置全局未捕获一场处理器
    addGlobalUncaughtErrorHandler((event) =>
        console.log('addGlobalUncaughtErrorHandler', event)
    )
}

export const regMicroApps = () => {
    return queryAuthority({ resourceType: 1 }).then((res) => {
        if (res && res.data) {
            let data = mockApps || res.data
            data = data.filter(
                (item) => item.childrenMenuList && item.childrenMenuList.length
            )
            console.log('--------', data)
            // TODO mock 上面设置为false 开关
            store.dispatch('app/setMenu', data)
            let menuData = groupMenu(data)
            initSubApp(menuData)
        }
    })
}
